import React from 'react';
import { useDispatch } from 'react-redux';
import styles from './OverlapBookingsModal.module.scss';
import { modalActions } from '../../../Modals/store';
import OverlapTaskCard from '../OverlapTaskCard';
import { useTranslation } from 'react-i18next';

const OverlapBookingsModal = ({
  overlapProps: { overlapTasks = [], day, workerId, searchParams },
  closeModal,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const openTaskInfo = (task) => {
    closeModal();
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type: 'taskInfoModal',
        props: {
          day,
          workerId,
          task,
          searchParams,
        },
      }),
    );
  };

  return (
    <div className={styles.container}>
      <p className={styles.subtitle}>
        {overlapTasks.length === 1
          ? t('scheduler.overlapBookingsModal.subtitleOne')
          : t('scheduler.overlapBookingsModal.subtitleMany', { count: overlapTasks.length })}
      </p>
      <ul className={styles.list}>
        {overlapTasks.map((task) => (
          <li key={task.idprenotazione}>
            <OverlapTaskCard task={task} onClick={() => openTaskInfo(task)} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OverlapBookingsModal;
